import React from 'react';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import { getCoverImageFile } from '../../../DeviationViews/Thumb/helpers';
export var JournalStageBackground = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var preview = getCoverImageFile({
        deviation: deviation,
        width: width,
        height: height,
        allowHuge: true,
    });
    return preview ? React.createElement(BackgroundImage, { src: preview.src }) : React.createElement(EmptyBackground, null);
};
JournalStageBackground.displayName = 'JournalStageBackground';
export default JournalStageBackground;
//# sourceMappingURL=Journal.js.map